import moment from 'moment-timezone'
import React from 'react'
import shuffle from '../js/shuffle'

export default class Schedule extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {}
  }

  render () {
    if (!this.state.schedule) return 'Loading...'
    return this.state.schedule.map((show, i) => {
      return (
        <div key={show.instance_id} className='mb-2'>
          <span style={{ color: '#53d6db' }}>{show.current ? <strong>NOW: </strong> : ''}{moment(show.starts).format('h:mma')} - {moment(show.ends).format('h:mma')}</span>
          {show.presenter_name ? <span className='float-end'><a href={`/presenters-and-shows/${show.alias}`}>{show.presenter_name}</a></span> : ''}
          <div className='text-start' style={{ fontWeight: 'bold' }}>{show.name}</div>
          { this.state.schedule.length - 1 <= i ? '' : <hr style={{ width: '75%', margin: '10px auto', marginRight: '0px' }} /> }
        </div>
      )
    })
  }

  componentDidMount () {
    this.socket = window.io('/schedule', { transports: ['websocket'] })
    this.socket.on('update', schedule => this.setState({ schedule }))
  }

  componentDidUpdate () {
    setTimeout(() => {
      shuffle.update()
    }, 100)
  }
}
